<template>
  <footer class="app-footer">
    <div class="footer-content">
      <a href="https://gitlab.com/spseol/Portfolio">Portfolio</a>
      <span v-if="version"> {{ version }}</span>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { api } from '../utils/axios'

const version = ref('')

onMounted(async () => {
  try {
    const response = await api.get('/version')
    // Formát: v0.4.0 (2026-01-10) [abc123]
    version.value = `v${response.data.version} (${response.data.build_date}) [${response.data.git_commit}]`
  } catch (error) {
    console.warn('Failed to fetch version:', error)
    version.value = 'v0.4.0'  // fallback
  }
})
</script>

<style scoped lang="scss">
.app-footer {
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.05);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
  z-index: 100;
}

.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}
</style>
